export default __webpack_public_path__ + "./images/payPal-small.41a84c1d.svg";